<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="附件名称">
              <a-input v-model.trim="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              label="上传时间"
              :labelCol="{lg: {span: 7}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
            >
              <a-range-picker
                v-model="queryParam.time"
                style="width: 100%"
                :disabledDate="disabledDate"
                :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                showTime
                format="YYYY-MM-DD HH:mm:ss"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="fileNameDown" slot-scope="text, record">
        <a
          :id="'f' + record.id"
          href="javascript:void(0)"
          @click="downloadfile(record)"
        >{{record.name}}.{{record.suffix}}</a>
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import { attachmentDeleteFileById, attachmentPage, attachmentDownFile } from '@/api/sys'

export default {
  name: 'Door',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      downloadUrl: this.config.downloadUrl,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {time:[moment().startOf('day'), moment().endOf('day')]},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '附件名',
          dataIndex: 'name',
          scopedSlots: { customRender: 'fileNameDown' }
        },
        {
          title: '上传时间',
          dataIndex: 'createTime',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '50px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = undefined
          this.queryParam['endTime'] = undefined
        }

        return attachmentPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return attachmentDeleteFileById({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    downloadfile(record) {
      let ea = document.getElementById('f' + record.id)
      if (ea.href == 'javascript:void(0)') {
        attachmentDownFile({ id: record.id })
          .then(res => {
            if (res && res.code && res.code != 0) {
              // this.$message.error(res.message)
            } else {
              ea.href = this.downloadUrl + record.id
              ea.click()
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
<style scoped>
/* tile uploaded pictures */
.upload-list-inline >>> .ant-upload-list-item {
  float: left;
  width: 200px;
  margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
  animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
  animation-name: uploadAnimateInlineOut;
}
</style>